/**
 * PDF Export Renk Yönetim Sistemi
 * Tüm PDF export renklerini API'den alır ve cache'ler
 */

import store from "@/store";

// Renkleri cache'lemek için
let cachedColors = null;
let isLoading = false;
let loadPromise = null;

// Varsayılan renkler (API yüklenene kadar veya hata durumunda)
const defaultColors = {
  // Metin renkleri
  correctAnswer: "red",
  referenceLabel: "blue",
  referenceTitle: "red",
  referenceLink: "green",

  // Referans çerçevesi renkleri (mavi tonlar)
  questionHeaderBg: "#cccff1",
  notesSidebarBg: "#b2b4ce",

  // Border ve çerçeve renkleri
  pageBorder: "#c00002",

  // Footer renkleri
  footerBg: "#f90500",
  footerText: "#fff",

  // Diğer renkler
  osymText: "#f90500"
};

/**
 * API'den PDF renklerini yükler
 * @returns {Promise<Object>} Renk kodlarını içeren obje
 */
const loadPdfColorsFromApi = async () => {
  if (isLoading && loadPromise) {
    return loadPromise;
  }

  if (cachedColors) {
    return cachedColors;
  }

  isLoading = true;
  loadPromise = (async () => {
    try {
      const result = await store.dispatch("getDatas", {
        api: "References/GetPdfColors"
      });

      if (result && result.result === true && result.data) {
        cachedColors = result.data;
        console.log("[PDF_COLORS] Renkler API'den yüklendi:", cachedColors);
        return cachedColors;
      } else {
        console.warn(
          "[PDF_COLORS] API'den renkler yüklenemedi, varsayılan renkler kullanılıyor"
        );
        cachedColors = defaultColors;
        return cachedColors;
      }
    } catch (error) {
      console.error("[PDF_COLORS] API çağrısı hatası:", error);
      cachedColors = defaultColors;
      return cachedColors;
    } finally {
      isLoading = false;
      loadPromise = null;
    }
  })();

  return loadPromise;
};

/**
 * PDF export için kullanılan renkleri döndürür
 * @param {boolean} forceReload - Cache'i bypass edip API'den tekrar yükle
 * @returns {Promise<Object>} Renk kodlarını içeren obje
 */
export const getPdfColors = async (forceReload = false) => {
  if (forceReload) {
    cachedColors = null;
  }

  if (cachedColors) {
    return cachedColors;
  }

  return await loadPdfColorsFromApi();
};

/**
 * Belirli bir renk kodunu döndürür (sync versiyon - cache'den)
 * @param {string} colorKey - Renk anahtarı (örn: 'correctAnswer', 'referenceLabel')
 * @returns {string} Renk kodu
 */
export const getPdfColor = colorKey => {
  // Cache'den al, yoksa varsayılan
  const colors = cachedColors || defaultColors;
  return colors[colorKey] || "#000000"; // Varsayılan siyah
};

/**
 * Belirli bir renk kodunu döndürür (async versiyon - API'den)
 * @param {string} colorKey - Renk anahtarı
 * @returns {Promise<string>} Renk kodu
 */
export const getPdfColorAsync = async colorKey => {
  const colors = await getPdfColors();
  return colors[colorKey] || "#000000";
};

/**
 * Renkleri yeniden yükler (cache'i temizler)
 */
export const reloadPdfColors = () => {
  cachedColors = null;
  return loadPdfColorsFromApi();
};
